module.exports = {
        srcSet: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp"+" 200w",
        images: [{path: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp",width: 200,height: 200}],
        src: "/_next/static/images/madhu-venkatesh-200.444b0de5.webp",
        toString: function(){return "/_next/static/images/madhu-venkatesh-200.444b0de5.webp"},
        
        width: 200,
        height: 200
      }